import { Component, OnInit } from '@angular/core';
import { ReservationSummaryStoreService } from '../reservation-summary/services/reservation-summary-store.service';
import { ReservationSummaryApiService } from '../reservation-summary/services/reservation-summary-api.service';
import { Conversation } from '../reservation.model';
import { MatDialog } from '@angular/material/dialog';
import { ReservationMessageDialogComponent } from './reservation-message-dialog/reservation-message-dialog.component';
import { Observable } from 'rxjs';
import { ReservationMessageSendComponent } from './reservation-message-send/reservation-message-send.component';

@Component({
	selector: 'app-reservation-message-list',
	templateUrl: './reservation-message-list.component.html',
	styleUrls: ['./reservation-message-list.component.scss'],
})
export class ReservationMessageListComponent implements OnInit {
	constructor(
		private readonly store: ReservationSummaryStoreService,
		private readonly api: ReservationSummaryApiService,
		private readonly dialog: MatDialog,
	) {}
	displayedColumns: string[] = ['title', 'createdAt', 'unread', 'preview', 'archive', 'watch'];
	dataSource: Observable<Conversation[]>;
	private reservationId = null;
	loading = true;
	protected loadingStates: Map<string, boolean> = new Map();

	ngOnInit() {
		const { conversations, reservation } = this.store.getters();
		reservation().subscribe((value) => {
			if (value) {
				this.reservationId = value.id;
				this.api
					.actions()
					.getConversations(value.id)
					.then((value) => {
						if (value) {
							this.loading = false;
							this.dataSource = conversations();
						}
					});
			}
		});
	}

	openCreateMailDialog() {
		const dialogRef = this.dialog
			.open(ReservationMessageSendComponent, {
				data: this.reservationId,
				width: '75%',
			})
			.afterClosed()
			.subscribe(() => {
				dialogRef.unsubscribe();
				this.loading = true;
				// have to wait for the thread to be saved in the database to display it after adding
				setTimeout(() => {
					this.api
						.actions()
						.getConversations(this.reservationId)
						.then((value) => {
							if (value) this.loading = false;
						});
				}, 2000);
			});
	}

	protected async changeWatchingState(thread: Conversation) {
		const { watchThread, unwatchThread } = this.api.actions();
		this.loadingStates.set(thread.id + '_watch', true);
		await (thread.watching ? unwatchThread(thread.id) : watchThread(thread.id));
		this.store.mutations().setMessages([]);
		await this.api.actions().getConversations(this.reservationId);
		setTimeout(() => {
			this.loadingStates.set(thread.id + '_watch', false);
		}, 200);
	}

	openPreviewDialog(conversation: Conversation) {
		const dialogRef = this.dialog
			.open(ReservationMessageDialogComponent, {
				data: {
					conversation: conversation,
				},
				width: '75%',
			})
			.afterClosed()
			.subscribe(() => {
				dialogRef.unsubscribe();
				this.store.mutations().setMessages([]);
				this.loading = true;
				this.api
					.actions()
					.getConversations(this.reservationId)
					.then((value) => {
						if (value) this.loading = false;
					});
			});
	}

	protected isArchived(thread: Conversation) {
		return thread.labels.includes('archived');
	}

	protected async changeArchivedState(thread: Conversation) {
		const { patchThread } = this.api.actions();
		this.loadingStates.set(thread.id + '_archived', true);
		if (this.isArchived(thread)) {
			thread.labels = thread.labels.filter((v: string) => v !== 'archived');
		} else thread.labels.push('archived');
		await patchThread(thread.id, { labels: thread.labels });
		this.store.mutations().setMessages([]);
		await this.api.actions().getConversations(this.reservationId);
		setTimeout(() => {
			this.loadingStates.set(thread.id + '_archived', false);
		}, 200);
	}
}
